import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { useAuthStore } from "@/shared/stores/use-auth-store";

export const authorizationHeaderInterceptor = async (config: InternalAxiosRequestConfig) => {
    const authStore = useAuthStore();
    await authStore.waitUntilTokenAvailable(); // Ensure the token is available before making the request
    if (authStore.isTokenAvailable) {
        config.headers.set("Authorization", `Bearer ${authStore.token.access_token}`);
    }
    return config;
};

export const addAuthorizationHeaderInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(authorizationHeaderInterceptor);
};
